import { Instance } from 'mobx-state-tree';
import { ProjectOptimizeStartedDtoModelBase } from './ProjectOptimizeStartedDtoModel.base';

/* The TypeScript type of an instance of ProjectOptimizeStartedDtoModel */
export interface ProjectOptimizeStartedDtoModelType extends Instance<typeof ProjectOptimizeStartedDtoModel.Type> {}

/* A graphql query fragment builders for ProjectOptimizeStartedDtoModel */
export { selectFromProjectOptimizeStartedDto, projectOptimizeStartedDtoModelPrimitives, ProjectOptimizeStartedDtoModelSelector } from './ProjectOptimizeStartedDtoModel.base';

/**
 * ProjectOptimizeStartedDtoModel
 *
 * Optimize started
 */
export const ProjectOptimizeStartedDtoModel = ProjectOptimizeStartedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
